import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  useGetAssignmentMarkQuery,
  useGetVideoAssignmentQuery,
  useSubmitAssignmentMutation,
} from "../../features/assignments/assignemntsApi";
import {
  useGetQuizMarkQuery,
  useGetQuizzesByVedioIdQuery,
} from "../../features/quizzes/quizzesApi";
import isoDateToformattedDate from "../../utils/isoDateToformattedDate";

export default function Description({ video }) {
  const user = useSelector((state) => state.auth.user);
  const { data: assignmentData } = useGetVideoAssignmentQuery(video.id);
  const assignment = assignmentData?.find((assignment) => true);

  const { data: assignmentMark } = useGetAssignmentMarkQuery(
    {
      assignmentId: assignment?.id,
      studentName: user?.name,
    },
    {
      skip: !assignmentData,
    }
  );

  const [submitAssignment] = useSubmitAssignmentMutation();
  const { data: quiz } = useGetQuizzesByVedioIdQuery(video.id);
  const { title, description, createdAt } = video;
  const formattedDate = isoDateToformattedDate(createdAt);
  const [assignmentForm, setAssignmentForm] = useState(false);
  const assignmentFormWrapperRef = useRef();
  const repoRef = useRef();
  const { data: quizMark } = useGetQuizMarkQuery({
    studentId: user.id,
    videoId: video.id,
  });

  const handleWrapperClick = (e) => {
    if (e?.target === assignmentFormWrapperRef?.current) {
      setAssignmentForm(false);
    }
  };

  const handleAssignmentSubmit = (e) => {
    e.preventDefault();
    const currentDate = new Date().toISOString();
    const data = {
      student_id: user?.id,
      student_name: user?.name,
      assignment_id: assignment?.id,
      title: assignment?.title,
      createdAt: currentDate,
      totalMark: assignment?.totalMark,
      mark: 0,
      repo_link: repoRef.current.value,
      status: "pending",
    };
    submitAssignment({
      assignmentId: assignment?.id,
      studentName: user?.name,
      data,
    });
    setAssignmentForm(false);
  };

  return (
    <>
      <div>
        <h1 className="text-lg font-semibold tracking-tight text-slate-100">
          {title}
        </h1>
        <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
          Uploaded on {formattedDate}
        </h2>

        <div className="flex items-center gap-4">
          {assignmentMark?.length === 0 && assignment?.id && (
            <span
              onClick={() => setAssignmentForm(true)}
              className="px-3 cursor-pointer font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
            >
              এসাইনমেন্ট
            </span>
          )}

          {quiz?.length > 0 && quizMark?.length === 0 && (
            <Link
              to={`/quiz/${video?.id}`}
              className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
            >
              কুইজে অংশগ্রহণ করুন
            </Link>
          )}
          {quiz?.length === 0 && (
            <span
              className="text-red-500 text-xs   -space-y-px
            px-3 font-bold py-1 border border-red-500 rounded-full"
            >
              কুইজ নেই
            </span>
          )}
          {assignmentMark?.length > 0 && (
            <span
              className="text-green-500 text-xs   -space-y-px
            px-3 font-bold py-1 border border-green-500 rounded-full"
            >
              অ্যাসাইনমেন্ট জমা দিয়েছেন
            </span>
          )}
          {quizMark?.length > 0 && (
            <span
              className="text-green-500 text-xs   -space-y-px
            px-3 font-bold py-1 border border-green-500 rounded-full"
            >
              কুইজ দিয়েছেন
            </span>
          )}
        </div>
        <p className="mt-4 text-sm text-slate-400 leading-6">{description}</p>
      </div>

      <div
        onClick={handleWrapperClick}
        className={`assignmentFormWrapper ${assignmentForm && "vissible"}`}
        ref={assignmentFormWrapperRef}
      >
        <form
          onSubmit={handleAssignmentSubmit}
          className={`assignmentForm bg-primary border border-slate-50/10 
           ${assignmentForm && "vissible"}`}
        >
          <i
            onClick={() => setAssignmentForm(false)}
            className="fas fa-times "
          ></i>

          <h2 className="heading">
            Submit the <span> assignment</span>
          </h2>
          <span className="assignment-name">
            Assignment name : {assignment?.title}
          </span>
          <div className="formGroup">
            <label htmlFor="repositoryLinkInput">Github repository link</label>
            <input
              ref={repoRef}
              className="bg-slate-900 p-2 "
              type="text"
              id="repositoryLinkInput"
            />
          </div>

          <button type="submit" className="bg-violet-600 px-4 py-2 rounded-md">
            Submit
          </button>
        </form>
      </div>
    </>
  );
}
